import { render, staticRenderFns } from "./PurchasingLoanList.vue?vue&type=template&id=2f81108f&scoped=true&"
import script from "./PurchasingLoanList.vue?vue&type=script&lang=js&"
export * from "./PurchasingLoanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f81108f",
  null
  
)

export default component.exports